/// <reference path="./include/global.d.ts" />

/** Imports */
import { PageAbstract, waitLangText } from './abs/pageAbstract';
import { Buscador } from './include/buscador/buscador';
import { Comentarios } from './include/comentarios';

/** Dependencias */
import '../stylus/landing.sass'
//import '../assets/fonts/custom_icons/custom_icons.styl'
import '../librerias/OwlCarousel/assets/owl.carousel.min.css'
import '../librerias/OwlCarousel/assets/owl.theme.default.min.css'
import '../librerias/OwlCarousel/owl.carousel.min.js'

/** Boostrap */
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';

export class Landing extends PageAbstract {

	/** constructor */
	constructor() {
		super();
	}

	init() {
		new Buscador().iniciar();
		this.iniciarCarrousel();
	}

	loadDeferred() {
		this.hoverCards();
		this.initButtonCarrousel();
		this.listenFaqs();
		this.initCarouselMedios();
		new Comentarios().setVerMas();
	}


	listenFaqs() {
		$('.faq').on('click', function () {
			var $icon = $(this).find('.alk');  // Buscar el elemento i con la clase alk dentro del elemento faq
			// Verificar si el elemento está colapsado
			if ($(this).hasClass('collapsed')) {
				// El elemento está colapsado, cambiar clases del ícono
				$icon.removeClass('alk-angle-up').addClass('alk-angle-down');
			} else {
				// El elemento no está colapsado, cambiar clases del ícono
				$icon.removeClass('alk-angle-down').addClass('alk-angle-up');
			}
		});
	}

	hoverCards() {
		$(".card").on({
			click: function () {
				$(this).toggleClass('active');
			},
			mouseenter: function () {
				$(this).addClass('active');
			},
			mouseleave: function () {
				$(this).removeClass('active');
			}
		});
	}

	initButtonCarrousel() {
		$(".seleccionar").on("click", function () {
			$("#buscar").trigger("click");
		});

		$(".link-rentadora").on("click", function () {
			let idRent = $(this).data('id');
			const $form = $('#form-busqueda');
			let url = $form.attr('action') + '?' + new URLSearchParams($form.serialize()).toString();
			url += '&filter-rent=' + idRent;
			window.location.href = url;
		});
	}

	/**
	 * Método para iniciar el carrusel de la vista cuadricula
	 * @param {*} map
	 */
	iniciarCarrousel() {
		$(".carousel-carros").owlCarousel({
			margin: 10,
			nav: true,
			dots: false,
			loop: false,
			animateOut: "fadeOut",
			navText: [
				'<i id="icon-prev-carros" class="alk alk-angle-left text-primary fs-2" aria-label="Previo" ></i>',
				'<i id="icon-next-carros" class="alk alk-angle-right text-primary fs-2"  aria-label="Siguiente" ></i>',
			],
			responsive: {
				0: {
					items: 1,
				},
				600: {
					items: 3,
				},
				900: {
					items: 4,
				},
				1000: {
					items: 4,
				},
				1200: {
					items: 5,
				},
				1300: {
					items: 6,
				},
			},
		});


		var ariaLabelIcono = $("#icon-prev-carros").attr("aria-label");
		var ariaLabelIconoNext = $("#icon-next-carros").attr("aria-label");

		// Encuentra el botón padre del icono y asigna el mismo aria-label
		$("#icon-prev-carros").parent(".owl-prev").attr("aria-label", ariaLabelIcono ? ariaLabelIcono : '');
		$("#icon-prev-carros").parent(".owl-prev").attr("role", 'button');
		$("#icon-next-carros").parent(".owl-next").attr("aria-label", ariaLabelIconoNext ? ariaLabelIconoNext : '');
		$("#icon-next-carros").parent(".owl-next").attr("role", 'button');
	}

	initCarouselMedios() {
		$('.carousel-rentadoras').owlCarousel({
			loop: false,
			nav: true,
			dots: false,
			margin: 6,
			navText: [
				'<i id="icon-prev-rentadoras" class="alk alk-angle-left text-primary" aria-label="Previo"></i>',
				'<i id="icon-next-rentadoras" class="alk alk-angle-right text-primary" aria-label="Siguiente"></i>',
			],
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 3
				},
				1000: {
					items: 4
				}
			}
		});

		var ariaLabelIcono = $("#icon-prev-rentadoras").attr("aria-label");
		var ariaLabelIconoNext = $("#icon-next-rentadoras").attr("aria-label");

		// Encuentra el botón padre del icono y asigna el mismo aria-label
		$("#icon-prev-rentadoras").parent(".owl-prev").attr("aria-label", ariaLabelIcono ? ariaLabelIcono : '');
		$("#icon-prev-rentadoras").parent(".owl-prev").attr("role", 'button');
		$("#icon-next-rentadoras").parent(".owl-next").attr("aria-label", ariaLabelIconoNext ? ariaLabelIconoNext : '');
		$("#icon-next-rentadoras").parent(".owl-next").attr("role", 'button');
	}
}

declare var google: any;

var instance: Landing = new Landing();
var loadDeferredHandled: boolean = false;

$(function () {
	waitLangText(() => {
		instance.init();
	});
});

const handleScroll = () => {
	if (!loadDeferredHandled) {
		instance.loadDeferred();
		loadDeferredHandled = true;
	}
};

const handleClick = () => {
	if (!loadDeferredHandled) {
		instance.loadDeferred();
		loadDeferredHandled = true;
	}
};

window.onscroll = handleScroll;
document.addEventListener("click", handleClick);


